import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LeaderboardBase } from '@/components/shared/leaderboard/LeaderboardBase';
import type { LeaderboardEntry, LeaderboardColumn } from '@/components/shared/leaderboard/LeaderboardBase';

export function LeaderboardProfileTest() {
  const navigate = useNavigate();

  // Sample leaderboard data
  const sampleEntries: LeaderboardEntry[] = [
    {
      id: 'user-1',
      rank: 1,
      name: 'Alex Johnson',
      score: 72,
      scoreDifferential: -2,
      avatar: 'https://ui-avatars.com/api/?name=Alex+Johnson&background=52B788&color=1B4332',
      isCurrentUser: false
    },
    {
      id: 'user-2',
      rank: 2,
      name: 'Sarah Smith',
      score: 74,
      scoreDifferential: 0,
      avatar: 'https://ui-avatars.com/api/?name=Sarah+Smith&background=52B788&color=1B4332',
      isCurrentUser: false
    },
    {
      id: 'user-3',
      rank: 3,
      name: 'Mike Davis',
      score: 76,
      scoreDifferential: 2,
      avatar: 'https://ui-avatars.com/api/?name=Mike+Davis&background=52B788&color=1B4332',
      isCurrentUser: true
    }
  ];

  const columns: LeaderboardColumn[] = [
    {
      key: 'rank',
      label: 'Rank',
      width: '60px',
      align: 'center'
    },
    {
      key: 'name',
      label: 'Player',
      width: 'auto',
      align: 'left'
    },
    {
      key: 'score',
      label: 'Score',
      width: '80px',
      align: 'center'
    },
    {
      key: 'scoreDifferential',
      label: '+/-',
      width: '60px',
      align: 'center'
    }
  ];

  const handleEntryClick = (entry: LeaderboardEntry) => {
    // Navigate to the user's public profile
    navigate(`/profile/${entry.id}`);
  };

  return (
    <div className="p-6 max-w-md mx-auto">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Leaderboard Profile Test</h2>
        <p className="text-gray-600">
          Click on any player name to view their public profile. This demonstrates how leaderboards can integrate with the public profile system.
        </p>
      </div>

      <LeaderboardBase
        entries={sampleEntries}
        columns={columns}
        title="Sample Leaderboard"
        subtitle="Click on players to view their profiles"
        showRankIcons
        allowExpansion={false}
        onEntryClick={handleEntryClick}
        variant="premium"
      />

      <div className="mt-6 p-4 bg-blue-50 rounded-lg">
        <h3 className="font-semibold text-blue-900 mb-2">How it works:</h3>
        <ul className="text-sm text-blue-800 space-y-1">
          <li>• Click on any player name in the leaderboard</li>
          <li>• You'll be navigated to their public profile page</li>
          <li>• The profile will show their stats, achievements, and social info</li>
          <li>• You can follow, message, or add them as a friend</li>
        </ul>
      </div>
    </div>
  );
} 